import * as React from 'react';
import { GoogleMap, Marker, InfoWindow } from '@react-google-maps/api';
import { MarkerClusterer } from '@react-google-maps/api';
import GeneralConstants from '../../constants/general.constants';
import StatusConstants from '../../constants/status.constants';
import ClipBoard from './clipboard';
import ClipboardLink from './clipboard-link.component';

import api from '../../services/api.service';
const isLoaded = true;

function addDays(date, days) {
    const copy = new Date(Number(date));
    copy.setDate(date.getDate() + days);
    return copy;
}

function dateFormat(time) {
    const d = new Date(time);
    return d
        .toLocaleDateString('en-GB')
        .replace(`, `, '-')
        .replace(`/`, '.')
        .replace(`/`, '.')
        .replace(/:[^:]*$/, '');
}

const MyMapComponent = ({ page, lat, lng }) => {

    /*
    const { isLoaded, loadError } = useLoadScript({
        googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
        libraries,
        // Add loading configuration
        loadingCallback: () => {
            console.log('Google Maps API loading started');
        },
        onLoad: () => {
            console.log('Google Maps API loaded successfully');
        },
        // Add async loading
        googleMapsApiVersion: 'weekly',
        language: 'no',
        region: 'NO',
        loading: 'async'
    });
    */

    const [matrix, setMatrix] = React.useState(null);
    const [filterProjects, setFilterProjects] = React.useState([]);
    const [selectedProject, setSelectedProject] = React.useState(null);
    const [currentLocation, setCurrentLocation] = React.useState(true);

    const markerIconRed = require('../../sass/gfx/icons/map/marker-red.svg');
    const markerIconPurple = require('../../sass/gfx/icons/map/marker-purple.svg');
    const markerIconTruck = require('../../sass/gfx/icons/map/marker-black.svg');

    const mapContainerStyle = {
        height: "600px",
        width: "100%"
    };

    const center = React.useMemo(() => ({
        lat: parseFloat(lat),
        lng: parseFloat(lng)
    }), [lat, lng]);

    React.useEffect(() => {

        async function fetchData() {
            const pageDaysFromNow = 7 * page;
            const curr = new Date();
            const pageDate = addDays(curr, pageDaysFromNow);
            const sunday = pageDate.getDate() - pageDate.getDay();
            const monday = new Date(pageDate.setDate(sunday + 1));

            const convertedDate = `${monday.getFullYear().toString()}-${(monday.getMonth() + 1)
                .toString()
                .padStart(2, 0)}-${monday.getDate().toString().padStart(2, 0)}`;

            const projectTypes = [
                'draft', 'order', 'confirmed', 'ready_for_rest',
                'ready_for_assembly', 'delivered', 'assembled',
                'ready'
            ];

            const fields = [
                'title,id,client_id,category,status,start_production_datetime,' +
                'end_production_datetime,start_assembly_datetime,end_assembly_datetime,' +
                'start_transport_datetime,end_transport_datetime&end_project_datetime=1'
            ];

            try {

                const projectResponse = await api.projects.get(
                    `?includes=client&datetime_range=0,${convertedDate},1` +
                    `&datetime_range_unit=W&project_status=${projectTypes}&fields=${fields}`
                );
                
                const complaintsResponse = await api.projects.get(
                    `?includes=client&datetime_range=12,${convertedDate},1` +
                    `&datetime_range_unit=W&project_status=complaints&fields=${fields}`
                );
                
                const projects = [...projectResponse, ...complaintsResponse];
                
                //console.log('All projects:', projectResponse);
                //console.log('All complaints:', complaintsResponse);

                const filtered = projects.filter(project => {
                    const hasValidAddress = project.client?.addresses?.[0]?.lat && project.client?.addresses?.[0]?.lng;
                    return project.client && project.client.addresses && hasValidAddress;
                });

                if (isLoaded && filtered.length > 0) {
                    const origins = [{
                        lat: parseFloat(lat),
                        lng: parseFloat(lng)
                    }];

                    const destinations = filtered.map(project => ({
                        lat: parseFloat(project.client.addresses[0].lat),
                        lng: parseFloat(project.client.addresses[0].lng)
                    }));

                    const distanceService = new window.google.maps.DistanceMatrixService();
                    try {
                        const result = await new Promise((resolve, reject) => {
                            distanceService.getDistanceMatrix(
                                {
                                    origins: origins,
                                    destinations: destinations,
                                    travelMode: window.google.maps.TravelMode.DRIVING,
                                    unitSystem: window.google.maps.UnitSystem.METRIC,
                                    avoidHighways: false,
                                    avoidTolls: false
                                },
                                (response, status) => {
                                    if (status === 'OK') {
                                        resolve(response);
                                    } else {
                                        reject(new Error(`Distance Matrix failed: ${status}`));
                                    }
                                }
                            );
                        });

                        setMatrix(result);
                        setFilterProjects(filtered);
                    } catch (error) {
                        setFilterProjects(filtered);
                    }
                }
            } catch (error) {
                console.error('Failed to fetch projects:', error);
            }
        }

        fetchData();
        
    }, [page, lat, lng, /*isLoaded*/]);

    /*
    if (loadError) return (
        <div className="map-error">
            Error loading Google Maps: {loadError.message}
        </div>
    );

    if (!isLoaded) return (
        <div className="map-loading">
            <div>Loading Google Maps...</div>
            <div className="loading-spinner"></div>
        </div>
    );
    */

    return (
        <>
            <GoogleMap
                mapContainerStyle={mapContainerStyle}
                zoom={13}
                center={center}
                options={{
                    zoomControl: true,
                    mapTypeControl: false,
                    scaleControl: true,
                    streetViewControl: false,
                    rotateControl: false,
                    fullscreenControl: true
                }}
            >
                <MarkerClusterer>
                    {(clusterer) => (
                        <>
                            <Marker
                                position={center}
                                icon={{
                                    url: markerIconTruck.default,
                                    scaledSize: new window.google.maps.Size(40, 40)
                                }}
                                onClick={() => setCurrentLocation(!currentLocation)}
                                clusterer={clusterer}
                            />
                            {/*currentLocation && (
                                
                                <InfoWindow
                                    position={center}
                                    onCloseClick={() => setCurrentLocation(false)}
                                >
                                    <div className='map-pointer-data-container'>
                                        <div className='map-pointer-data-wrapper'>
                                            <div className='map-pointer__project-title'>
                                                <span>{GeneralConstants['current_location']}</span>
                                            </div>
                                        </div>
                                    </div>
                                </InfoWindow>
                            )*/}

                            {filterProjects?.map(project => {
                                const address = project.client?.addresses?.[0];
                                if (!address?.lat) return null;

                                const position = {
                                    lat: parseFloat(address.lat),
                                    lng: parseFloat(address.lng)
                                };

                                return (
                                    <React.Fragment key={project.id}>
                                        <Marker
                                            position={position}
                                            icon={{
                                                url: project.status === 'complaints' ? markerIconRed.default : markerIconPurple.default,
                                                scaledSize: new window.google.maps.Size(48, 48)
                                            }}
                                            onClick={() => setSelectedProject(project)}
                                            clusterer={clusterer}
                                        />
                                        {selectedProject?.id === project.id && (
                                            <InfoWindow
                                                position={position}
                                                onCloseClick={() => setSelectedProject(null)}
                                            >
                                                <div className='map-pointer-data-container'>
                                                    <div className='map-pointer-data-wrapper'>
                                                        <div className='map-pointer__project-title'>
                                                            <a
                                                                href={`https://www.google.com/maps/dir/?api=1&origin=${lat},${lng}&destination=${address.lat},${address.lng}&travelmode=driving`}
                                                                target='_blank'
                                                                rel='noopener noreferrer'
                                                            >
                                                                {project.title}
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </InfoWindow>
                                        )}
                                    </React.Fragment>
                                );
                            })}
                        </>
                    )}
                </MarkerClusterer>
            </GoogleMap>

            <div className='map'>
                {matrix && (
                    <Row
                        directiondata={matrix.rows?.[0] || []}
                        projects={filterProjects}
                        lat={parseFloat(lat)}
                        lng={parseFloat(lng)}
                    />
                )}
            </div>
        </>
    );
};

const Row = ({ directiondata, projects, lat, lng }) => (
    <div className='map-item'>
        {directiondata.elements?.map((distance, i) => (
            <div className='map-item__data' key={i}>
                <div className='map-item__project-title'>
                    {projects[i].title}
                    {projects[i].client.addresses[0]?.google_address ? (
                        <div className='map-item__project-address'>
                            {projects[i].client.addresses[0].google_address}
                        </div>
                    ) : projects[i].client.addresses[0]?.address_line ? (
                        <ClipBoard address={projects[i].client.addresses[0].address_line} />
                    ) : null}
                </div>

                <div className='map-item__project-center-wrapper'>
                    <div className='map-item__project-start'>
                        <span className='map-item__project-label'>
                            {GeneralConstants['start_time']}
                        </span>
                        {['production', 'assembly', 'transport'].map(type => (
                            projects[i][`start_${type}_datetime`] && (
                                <div key={type} className={`map-item-time map-item-time--${type}`}>
                                    {dateFormat(projects[i][`start_${type}_datetime`])}
                                </div>
                            )
                        ))}
                    </div>

                    <div className='map-item__project-end'>
                        <span className='map-item__project-label'>
                            {GeneralConstants['end_time']}
                        </span>
                        {['production', 'assembly', 'transport'].map(type => (
                            projects[i][`end_${type}_datetime`] && (
                                <div key={type} className={`map-item-time map-item-time--${type}`}>
                                    {dateFormat(projects[i][`end_${type}_datetime`])}
                                </div>
                            )
                        ))}
                    </div>

                    <div className='map-item__project-id'>
                        <span className='map-item__project-label'>
                            {GeneralConstants['project_nr_short']}
                        </span>
                        {projects[i].id}
                    </div>
                </div>

                <div className='map-item__project-status status-container'>
                    <div className={`status ${projects[i].status} status--set`}>
                        {StatusConstants[projects[i].status]}
                    </div>
                </div>

                <div className='map-item__project-right-wrapper'>
                    <div className='map-item__project-distance'>
                        <span className='map-item__project-label'>
                            {GeneralConstants['distance']}
                        </span>
                        {distance.status === 'OK' 
                            ? distance.distance.text 
                            : GeneralConstants['not_found']}
                    </div>
                    {distance.status === 'OK' ? (
                        <div className='map-item__project-url'>
                            <a
                                href={`https://www.google.no/maps/dir/?api=1&origin=${lat},${lng}&destination=${projects[i].client.addresses[0].lat},${projects[i].client.addresses[0].lng}&travelmode=driving`}
                                target='_blank'
                                rel='noopener noreferrer'
                            >
                                {GeneralConstants['go']}
                            </a>
                        </div>
                    ) : projects[i].client.addresses[0]?.address_line ? (
                        <ClipboardLink address={projects[i].client.addresses[0].address_line} />
                    ) : null}
                </div>
            </div>
        ))}
    </div>
);

export default MyMapComponent;